<template lang="pug">
	.merchant-form
		VueFeedback(type="error")
			template(slot="feedback-title") Hoppá!
			template(slot="feedback-content") 
				p Sajnos jelentkezését nem sikerült mentenünk.
				p Kérjük #[a(@click="$emit('try-again')") próbálja meg újra]!
</template>
<script>
import VueFeedback from '@ui-common/vue-feedback';
export default {
	components: {
		VueFeedback
	},
	mounted() {
		this.$scrollTo(this.$el);
	}
};
</script>
